var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 4C8.39543 4 7.5 4.89543 7.5 6V26C7.5 27.1046 8.39543 28 9.5 28H23.5C24.6046 28 25.5 27.1046 25.5 26V11L18.5 4H9.5Z",
    fill: "#FC8F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0463 23.0469C11.7943 23.0469 11.5893 22.8418 11.5893 22.5898C11.5893 22.3438 11.7943 22.1387 12.0463 22.1387C12.2865 22.1387 12.4975 22.3438 12.4975 22.5898C12.4975 22.8418 12.2865 23.0469 12.0463 23.0469ZM13.0682 24.1953V19.8184H13.8006V20.3398H13.8475C13.9646 20.1113 14.199 19.7773 14.7615 19.7773C15.4939 19.7773 16.074 20.3516 16.074 21.4121C16.074 22.4609 15.5115 23.0586 14.7615 23.0586C14.2107 23.0586 13.9646 22.7305 13.8475 22.4961H13.8182V24.1953H13.0682ZM13.8006 21.4062C13.8006 22.0273 14.0701 22.4434 14.5564 22.4434C15.0486 22.4434 15.3123 22.0098 15.3123 21.4062C15.3123 20.8145 15.0545 20.3867 14.5564 20.3867C14.0701 20.3867 13.8006 20.791 13.8006 21.4062ZM17.6936 23.0586C16.9436 23.0586 16.3811 22.4609 16.3811 21.4121C16.3811 20.3516 16.9611 19.7773 17.6994 19.7773C18.2619 19.7773 18.4963 20.1113 18.6076 20.3398H18.6369V18.7578H19.3811V23H18.6486V22.4961H18.6076C18.4904 22.7305 18.2443 23.0586 17.6936 23.0586ZM17.8986 22.4434C18.3791 22.4434 18.6545 22.0273 18.6545 21.4062C18.6545 20.791 18.385 20.3867 17.8986 20.3867C17.4006 20.3867 17.1428 20.8145 17.1428 21.4062C17.1428 22.0098 17.4064 22.4434 17.8986 22.4434ZM21.5982 19.8184V20.3926H20.942V23H20.192V20.3926H19.7174V19.8184H20.192V19.5137C20.192 18.8926 20.5787 18.5586 21.1881 18.5586C21.3639 18.5586 21.5221 18.5762 21.6627 18.6055V19.1973C21.5396 19.1797 21.4459 19.1738 21.3932 19.1738C21.0885 19.1738 20.942 19.2969 20.942 19.584V19.8184H21.5982Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5067_661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 11V4L25.5 11H18.5Z",
    fill: "#FC4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5067_661",
    x: 14.5,
    y: 2,
    width: 15,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.20694 0 0 0 0 0.51735 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5067_661"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5067_661",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentPdf);
export default __webpack_public_path__ + "static/media/content-pdf.e23c465dfcda9e451d35b3071fa89531.svg";
export { ForwardRef as ReactComponent };